import { render, staticRenderFns } from "./JoinAgree.vue?vue&type=template&id=573eeaa2&scoped=true"
import script from "./JoinAgree.vue?vue&type=script&lang=js"
export * from "./JoinAgree.vue?vue&type=script&lang=js"
import style0 from "./JoinAgree.vue?vue&type=style&index=0&id=573eeaa2&prod&lang=scss"
import style1 from "./JoinAgree.vue?vue&type=style&index=1&id=573eeaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573eeaa2",
  null
  
)

export default component.exports